$(function () {

    let debounceTimer = null;

	$('[place-autocompleted-by]').each(function (index, placeInput) {
		let postalCodeId = placeInput.getAttribute('place-autocompleted-by');
		$(document).on('input', '#' + postalCodeId, function (event) {
            debounce(() => {
                if (this.value.length !== 5) return;

                $.post(route('post-autocomplete'), {
                    field: 'postalcode',
                    value: this.value,
                }, result => {
                    const values = Object.values(result);
                    if (values.length === 1 && values[0].code === this.value) {
                        fillPlaceField(postalCodeId, Object.keys(result)[0], values[0].name);
                        showAutocompleteResults(this, postalCodeId, []);
                        return;
                    }

                    showAutocompleteResults(this, postalCodeId, result);
                });
            })();
		});

        $(document).on('blur', '#' + postalCodeId, function (event) {
            setTimeout(() => {
                showAutocompleteResults(this, postalCodeId, []);
            }, 300);
        });
	});

    function debounce(func, timeout = 300) {
        return (...args) => {
            if (debounceTimer) clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    function showAutocompleteResults(node, id, result) {
        const containerId = `${ id }-autocomplete-container`;

        const currentContainer = node.parentElement.querySelector('#' + containerId);
        if (currentContainer) {
            currentContainer.remove();
        }

        if (!result || result.length == 0) return;

        const container = document.createElement('div');
        container.setAttribute('id', `${ id }-autocomplete-container`);
        container.classList.add('absolute', 'mt-1', 'z-20', 'p-2', 'bg-white', 'border', 'rounded', 'shadow-sm', 'max-h-[210px]', 'overflow-y-auto', 'min-w-max');

        for (const placeId in result) {
            let name = result[placeId].name;
            let code = result[placeId].code;

            const toRemove = ', Deutschland';
            if (name.endsWith(toRemove)) {
                name = name.slice(0, -toRemove.length);
            }

            const resultItem = document.createElement('div');
            resultItem.classList.add('cursor-pointer', 'p-2', 'hover:bg-gray-100', 'whitespace-nowrap', 'flex', 'items-center', 'justify-between', 'space-x-5');

            const placeNode = document.createElement('span');
            placeNode.classList.add('font-medium');
            placeNode.innerText = name;

            const codeNode = document.createElement('span');
            codeNode.classList.add('text-gray-500');
            codeNode.innerText = code;

            resultItem.appendChild(placeNode);
            resultItem.appendChild(codeNode);

            resultItem.addEventListener('click', () => {
                node.value = code;

                fillPlaceField(id, placeId, name);

                showAutocompleteResults(node, id, []);
            });

            container.appendChild(resultItem);
        }

        node.parentElement.appendChild(container);
    }

    function fillPlaceField(id, placeId, name) {
        if (placeId.startsWith('code:')) {
            $(`[place-autocompleted-by="${ id }"]`).val(name);
            $(`[place-autocompleted-by="${ id }"]`).trigger('input');
            return;
        }

        $.post(route('post-autocomplete'), {
            field: 'postalcode_details',
            value: placeId,
        }, result => {
            $(`[place-autocompleted-by="${ id }"]`).val(result.name ?? name);
            $(`[place-autocompleted-by="${ id }"]`).trigger('input');
        });
    }
});
